export interface AspNetBindingError {
  [propertyName: string]: string[]
}

export type AspNetResponseError = AspNetBindingError;

export interface AspNetErrorResponse {
  errors: AspNetResponseError
  type: string
  title: string
  status: number
  traceId: string
}

export function asAspnetErrorResponse(obj?: any|null): AspNetErrorResponse|null  {
  if (typeof obj === "undefined" || obj === null || typeof obj !== "object") {
    return null;
  }

  if (!obj.hasOwnProperty('errors') || typeof obj.errors !== "object" || obj.errors === null) {
    return null;
  }

  if (!obj.hasOwnProperty('title') || typeof obj.title !== "string" || obj.title === null) {
    return null;
  }

  if (!obj.hasOwnProperty('status') || typeof obj.status !== "number") {
    return null;
  }

  if (!obj.hasOwnProperty('traceId') || typeof obj.traceId !== "string" || obj.traceId === null) {
    return null;
  }

  return obj as AspNetErrorResponse;
}